import {hasImage} from '@wix/wix-events-commons-statics'
import {isFullWidth, isResponsive} from '../../../../../../../commons/selectors/environment'
import {getEvent} from '../../../../selectors/event'
import {DetailsPageAppProps} from '../../../app/interfaces'
import {connect} from '../../../runtime-context/context'
import {SideBySideLayout as SideBySideLayoutPresentation} from './side-by-side'

export interface SideBySideLayoutProps extends SideBySideLayoutRuntimeProps, SideBySideLayoutOwnProps {}

export interface SideBySideLayoutOwnProps {
  onClickRegistrationButton: Function
}

export interface SideBySideLayoutRuntimeProps {
  imageVisible: boolean
  fullWidth: boolean
  responsive: boolean
}

const mapRuntime = ({state, host}: DetailsPageAppProps): SideBySideLayoutRuntimeProps => ({
  imageVisible: hasImage(getEvent(state)),
  fullWidth: isFullWidth(state, host.dimensions),
  responsive: isResponsive(host),
})

export const SideBySideLayout = connect<SideBySideLayoutOwnProps, SideBySideLayoutRuntimeProps>(mapRuntime)(
  SideBySideLayoutPresentation,
)
